import React, {Component} from 'react';
import classes from './CreateBoard.module.css';
import styled from 'styled-components';
import CloseImage from './close.svg';

const Container = styled.div`
width: 345px;
height: auto;
margin: 20px;
background-color: #9fe7a4;
padding: 30px 0;
display: -webkit-box;
display: -webkit-flex;
display: -ms-flexbox;
display: flex;
-webkit-flex-direction: column;
-ms-flex-direction: column;
flex-direction: column;
-webkit-box-pack: center;
-webkit-justify-content: center;
-ms-flex-pack: center;
justify-content: center;
-webkit-align-items: center;
-webkit-box-align: center;
-ms-flex-align: center;
align-items: center;
border-radius: 5.5px;
box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
cursor: pointer;
-webkit-transition: 200ms ease-in-out;
transition: 200ms ease-in-out;
font-weight: 900;
text-shadow: 0px 0px 3px #000;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border-bottom: ${props => !props.opened ? 'none' : '1px solid white'};
  width: 100%;
`;

const Title = styled.h3`
color: white;`;

const Name = styled.p`
color: white;`;

const BoardName = styled.input`
padding: 11px 15px;
font-size: 16px;
border-radius: 5px;
border: 2.5px solid rgba(255, 255, 255, 0.8);
width: 100%;
-webkit-box-shadow: 0 3px 3px rgba(0,0,0,0.16), 0 3px 3px rgba(0,0,0,0.23);
box-shadow: 0 3px 3px rgba(0,0,0,0.16), 0 3px 3px rgba(0,0,0,0.23);
width: 200px;`;

const Controls = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 15px 0px;
  `;

const Close = styled.button`
background-color: transparent;
width: 34px;
height: 34px;
border: none;
background-image: url(${CloseImage});
background-repeat: no-repeat;
background-position: center;
`;

const Cancel = styled.button`
width: auto;
height: 43px;
margin: 15px -5px 5px;
text-transform: uppercase;
cursor: pointer;
-webkit-transition: all 200ms ease-in-out;
transition: all 200ms ease-in-out;
border: none;
background: none;
color: white;
font-weight: 900;
text-shadow: 0px 0px 3px #000;
`;
const Create = styled.button`
width: 114px;
height: 43px;
margin: 15px 18px 5px;
text-transform: uppercase;
cursor: pointer;
-webkit-transition: all 250 ease-in-out;
transition: all 250 ease-in-out;
border: none;
box-shadow: 0 3px 3px rgba(0,0,0,0.16), 0 3px 3px rgba(0,0,0,0.23);
`;

export default class CreateBoard extends Component {
  state = {
    opened: false
  }

  onTitleClickHandler = (e) => {
    this.setState({
      opened: true
    })
  }

  onCloseButtonClickHandler = (e) => {
    this.setState({
      opened: false
    })
  }

  onCancelClickHandler = (e) => {
    e.target.parentNode.previousElementSibling.value = '';
  }

  render() {
    let content = (
      <Container>
        <Header>
          <Title onClick={this.onTitleClickHandler}>Create new board</Title>
        </Header>
      </Container>
      
    );
    if(this.state.opened) {
      content = (
        <Container>
        <Header opened={this.state.opened} className={classes.header}>
          <Title>Creating a board...</Title>
          <Close onClick={this.onCloseButtonClickHandler} type="button"></Close>
        </Header>
        
        <div className={classes.section}>
          <Name> Как будет называться доска? </Name>
          <BoardName onKeyDown={this.props.enterKeyDown} type="text"/>
          <Controls>
            <Cancel onClick={this.onCancelClickHandler} type="button"> Отмена </Cancel>
            <Create onClick={this.props.click} type="button"> Создать </Create>
          </Controls>
        </div>
      </Container>  
      )
    }


    return content;
  }
}
